// Міні-піктограма одного інвертора в групі.
//
// Свідомо НЕ картка: 19 інверторів на КТП × 6 КТП = понад сотня вузлів, і
// картками схема перетворилась би на стіну. Тут — кнопка 14×20 px із
// корпусом і індикатором, тобто рівно стільки, щоб побачити стан і клікнути.
import i18n from '@/i18n';
import { scada, stateColor } from '@/scada/tokens';
import type { SchemeInverter } from './types';

export default function InverterNode({ inv, selected, onSelect }: {
  inv: SchemeInverter;
  selected: boolean;
  onSelect: () => void;
}) {
  const c = stateColor(inv.state);
  // Непрацюючі — приглушені, а не пофарбовані: сірий корпус читається як
  // «не в роботі» сам по собі, без додаткового кольору.
  const dim = inv.state === 'offline';

  return (
    <button
      type="button"
      onClick={onSelect}
      title={`${inv.id} · ${Math.round(inv.powerKw)} ${i18n.t('ak_scada2_kw')}`}
      aria-label={inv.id}
      style={{
        width: 14, height: 20, padding: 0, cursor: 'pointer',
        background: dim ? scada.panel2 : `${c}1F`,
        border: `1px solid ${selected ? c : dim ? scada.border : `${c}66`}`,
        outline: selected ? `1px solid ${c}` : 'none',
        outlineOffset: 1,
        borderRadius: 3,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: 2, flexShrink: 0,
        transition: 'border-color .15s ease, background .15s ease',
      }}
    >
      {/* Індикатор + вентиляційні щілини — мінімальний «корпус інвертора». */}
      <span style={{ width: 4, height: 4, borderRadius: 999, background: dim ? scada.textMuted : c }} />
      <span style={{ width: 8, height: 1, background: scada.border }} />
      <span style={{ width: 8, height: 1, background: scada.border }} />
    </button>
  );
}
